<template>
  <div class="qr-code-apple">
    <ImageElement
      aria-hidden="true"
      render-without-figure
      lazy
      src="/content/content-images/dcb/56423e4d82879b2facd42c05026c775e/apple-qr.svg"
      class="qr-code-apple__code"
    />
    <br />
    <LinkButton
      tag="a"
      text
      target="_blank"
      is-external
      :to="appStore"
    >
      Für iOS/Apple
    </LinkButton>
  </div>
</template>

<script setup lang="ts">
import { ImageElement, LinkButton } from '@i22team/td-longtail-vue-components';
import { appStore } from './qr-code-links';
</script>

<style lang="scss" scoped>
.qr-code-apple {
  &__code {
    background: white;
    width: 120px;
  }
}
</style>
